module.exports = __webpack_public_path__ + "static/media/ERPH0DMWsAEWBjy.0fbe1aa5.jpg";